<template>
  <div class="container">
    <div class="title"><span>首页</span>>  <span>PETCT/MR中心</span> </div>
    <div class="neir">
      <div class="l">
          <div class="t">
            <div class="tipH3">
              <h3>{{detail.hospitalModel.name}}</h3>
              <span>推荐</span>
            </div>
            <p class="text">医院优势：{{detail.hospitalModel.sellPoint}}</p>
            <!--<div class="imgBox">-->
              <!--<img src="../../assets/image/5873e58b28dcb806029c279c3b6c732e.png" alt="">-->
              <div class="divR">
                <!--<p>检查费用：7000元 </p>-->
                <!--<p> 医院等级：影像中心</p>-->
                <!--<p>设备型号：Siemens Biograph 64 HD </p>-->
                <!--<p>工作时间：周一~周五:8:00-16:30，周六:8:00-12:00</p>-->
                <!--<p>医院地址：北京市徐汇区桂林路406号华鑫中心8号楼</p>-->
                 <span class="btn" @click="show">立即预约</span>
              </div>
            <!--</div>-->
            <p class="tipP"><i></i>医院介绍</p>
            <div class="text2" v-html="detail.hospitalModel.description"></div>
          </div>
      </div>
      <div class="r">
        <div class="top">
          <div class="lT">
            <ul class="list">
              <li class="active">热门PETCT/MR医院 <p></p></li>
            </ul>
          </div>
          <ul class="lB">
            <li v-for="item in detail.hospitalModelList" :key="item.id" @click="goinfo(item.id)">
              <img :src="item.picUrl" alt="">
              <div>
                <h3>{{item.name}}</h3>
                <p class="des">{{item.sellPoint}}</p>
                <p>￥{{item.salesPrice}}</p>
              </div>
            </li>
          </ul>
        </div>
        <!--<div class="b">-->
          <!--<p>扫描下方二维码咨询在线客服</p>-->
          <!--<img src="../../assets/image/rwm2.png" alt="">-->
          <!--<p>微信扫一扫</p>-->
        <!--</div>-->
      </div>
      <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="30%">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="预约日期" prop="appointmentTime">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.appointmentTime"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              style="width: 100%;"
            >
            </el-date-picker>

          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="idCard">
            <el-input v-model="ruleForm.idCard" placeholder="请输入身份证号码"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="ruleForm.sex">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="糖尿病" prop="isDm">
            <el-radio-group v-model="ruleForm.isDm">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="病情" prop="remark">
            <textarea v-model="ruleForm.remark" placeholder="请输入病情描述，50字以内" style="width: 100%; height: 100px;padding: 10px" maxlength="50"></textarea>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submit">立即提交</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  // import commonTable from '@/components/commonTable.vue'hospitalInfo
  import server from '@/service/server.js'
export default {
    name: 'index',
  components: {
    // commonTable
  },
    data () {
        return {
          dialogVisible: false,
          title: '',
          id: "",
          detail: {
            hospitalModel: {
              name: '',
              salesPrice: ''
            }
          },
          ruleForm: {
            appointmentTime: '',
            name: '',
            phone: '',
            idCard: '',
            isDm: '',
            sex: '',
            remark: '',
            category: '0'
          },
          rules: {
            department: [
              { required: true, message: '请输入检测部位', trigger: 'blur' }
            ],
            idCard: [
              { required: true, message: '请输入身份证号码', trigger: 'blur' }
            ],
            name: [
              { required: true, message: '请输入姓名', trigger: 'blur' }
            ],
            phone: [
              { required: true, message: '请输入手机号', trigger: 'blur' }
            ],
            remark: [
              { required: true, message: '请输入', trigger: 'blur' }
            ],
            appointmentTime: [
              { required: true, message: '请选择日期', trigger: 'change' }
            ],
            sex: [
              { required: true, message: '请选择', trigger: 'change' }
            ],
            isDm: [
              { required: true, message: '请选择', trigger: 'change' }
            ]
          }
        }
    },
    methods: {
      goinfo(id) {
        this.$router.push({
          path: `/xxjs?id=${id}`
        })
      },
      show() {
        this.dialogVisible = true
      },
      submit() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            this.ruleForm.sex = this.ruleForm.sex == '男' ? '1' : '0'
            this.ruleForm.isDm = this.ruleForm.isDm == '是' ? '1' : '0'
            this.ruleForm.modelId =  this.id
            this.ruleForm.modelName = this.detail.hospitalModel.name
            this.ruleForm.salesPrice = this.detail.hospitalModel.salesPrice
            server.order(this.ruleForm).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: '预约成功',
                  type: 'success'
                });
                this.dialogVisible = false
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    created(){
      this.id = this.$route.query.id
      console.log(this.$route.query.id)
    },
    mounted(){
      server.hospitalInfo(this.id).then((res) => {
        console.log(res.data)
        this.detail = res.data
        this.title = `在线预约：【${this.detail.hospitalModel.name}】`
      })
      document.documentElement.scrollTop = 0;
    }

}
</script>
<style lang="scss" scoped>
  /deep/ .el-dialog__footer{
    text-align: center;
     .el-button--primary {
      background-color: #CB0E07;
       border: none;
    }
  }
  .container {
    width: 1370px;
    margin: 0 auto;
    .title {
      padding: 10px 20px;
      background-color: #FFFFFF;
      margin: 20px 0;
      font-size: 16px;
      span {
        color: #5288F0;
      }
    }
    .neir{
      display: flex;
      .l{
        width: 1010px;
       .t{
         margin-bottom: 200px;
          .tipH3{
            display: flex;
            margin-bottom: 20px;
            h3{
              font-size: 42px;
              /*font-family: Adobe Heiti Std;*/;
              font-weight: normal;
              color: #0D0C0C;
            }
            span{
              width: 47px;
              height: 32px;
              background: rgba(203, 14, 7, 1);
              font-size: 21px;
              /*font-family: SimSun;*/
              font-weight: 400;
              color: #FFFFFF;
              text-align: center;
              line-height: 32px;
              display: inline-block;
              margin-top: 15px;
            }
          }
         .text{
           font-size: 18px;
           /*font-family: Adobe Kaiti Std;*/
           font-weight: normal;
           color: #000000;
         }
         .imgBox{
           display: flex;
           margin: 30px 0 50px;
           img{
             width: 421px;
             height: 295px;
           }

         }
         .divR{
           width: calc(100% - 0px);
           margin-left: auto;
           overflow: hidden;
           p{
             font-size: 18px;
             /*font-family: Adobe Kaiti Std;*/
             font-weight: normal;
             color: #000000;
             line-height: 21px;
             margin-bottom: 15px;
           }
           .btn{
             width: 100px;
             height: 40px;
             background: #CB0E07;
             border-radius: 6px;
             float: right;
             display: inline-block;
             font-size: 18px;
             /* font-family: SimSun; */
             /* font-weight: 400; */
             color: #FFFFFF;
             text-align: center;
             line-height: 40px;
             margin-top: 30px;
             cursor: pointer;
           }
         }
         .tipP{
           margin: 20px 0 30px;
           font-size: 25px;
           /*font-family: Adobe Heiti Std;*/;
           font-weight: normal;
           color: #CB0E07;
           line-height: 39px;
           text-align: center;
           i{
             display: inline-block;
             width: 28px;
             height: 28px;
             background: url("../../assets/image/qd.png") no-repeat;
             background-size: cover;
             vertical-align: middle;
             margin-right: 5px;
           }
         }
         .text2{
           font-size: 18px;
           /*font-family: Adobe Kaiti Std;*/
           font-weight: normal;
           color: #000000;
           text-align:left;
           text-indent:2em;
           line-height: 32px;
           overflow: hidden;
         }
         .name{
           font-size: 24px;
           color: rgba(0, 0, 0, 1);
           /*font-family: Adobe Kaiti Std;*/
           font-weight: normal;
           margin-bottom: 20px;
         }
         p.js{
           span{
             font-size: 18px;
             color: rgba(0, 0, 0, 1);
             /*font-family: Adobe Kaiti Std;*/
             font-weight: normal;
             display: inline-block;
             margin-right: 50px;
             margin-bottom: 20px;
           }
         }
         .tipH{
           font-size: 20px;
           /*font-family: Adobe Kaiti Std;*/
           font-weight: normal;
           color: #000000;
           margin-top: 30px;
         }
       }
      }
      .r{
        width: calc(100% - 1030px);
        margin-left: 20px;
        .top{
         width: 100%;
          /*height: 25%;*/
          background: #FFFFFF;
          border: 2px solid #EAEBEB;
          .lT{
            width: 100%;
            .list{
              margin-bottom: 10px;
              li{
                text-align: center;
                cursor: pointer;
                font-size: 19px;
                /*font-family: Adobe Heiti Std;*/;
                font-weight: normal;
                color: #000000;
                line-height: 33px;
                padding-top: 10px;
                p{
                  width: 97px;
                  height: 4px;
                  background: rgba(0, 180, 247, 0);
                  margin: 10px auto 0;
                }
              }
              li.active{
                p{
                  background: rgba(0, 180, 247, 1);
                }
              }
            }
          }
          .lB{
            width: 100%;
            padding: 0 20px;
            li{
              border-bottom: 1px solid rgba(209, 213, 213, 1);
              display: flex;
              margin-bottom: 20px;
              cursor: pointer;
              &:hover {
                img {
                  transform: scale(1.1);
                }
              }
              img{
                width: 130px;
                height: 91px;
                transition: all 0.5s;
              }
              div{
                padding: 4px 0;
                margin-left: 10px;
                width: calc(100% - 140px);
                h3{
                  font-size: 16px;
                  /*font-family: Adobe Heiti Std;*/;
                  font-weight: normal;
                  color: #000000;
                  width: 100%;
                  overflow:hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                p:nth-child(3){
                  color: rgba(203, 14, 7, 1);
                  font-size: 16px;
                }
                p{
                  font-size: 14px;
                  /*font-family: Adobe Heiti Std;*/;
                  font-weight: normal;
                  color: #B7BEBE;
                  /*line-height: 32px;*/
                  overflow:hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  margin: 10px 0;
                }
              }
            }
          }
        }
        .b{
          width: 323px;
          border: 1px solid #E1E3EA;
          box-shadow: 0px 3px 7px 0px rgba(35,24,21,0.35);
          border-radius: 15px;
          margin-top: 30px;
          margin-left: 10px;
          padding: 20px;
          box-sizing: border-box;
          p:nth-child(1){
            font-size: 21px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #000000;
            text-align: center;
            border-bottom: 1px solid rgba(210, 214, 214, 1);
            padding-bottom: 10px;
          }
          img{
            width: 150px;
            height: 150px;
            display: block;
            margin: 10px auto;
          }
          p:nth-child(3){
            font-size: 21px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #000000;
            text-align: center;
          }
        }
      }
    }
  }
  @media (max-width: 750px) {
    .container {
      width: 100%;
      margin-top: 60px;
      .neir {
        display: block;
        padding: 15px;
        background-color: #FFFFFF;
        .l {
          width: 100%;
          .t {
            .divR .btn {
              display: none;
            }
            .tipH3 {

              h3 {
                font-size: 20px;
              }
              display: block;
              span {
                display: none;
              }
            }
            .text {
              font-size: 14px;
              color: #535353;
            }
            img {
              width: 120px;
              height: 120px;
            }
            div {
              .zc {
                font-size: 16px;
              }
              p {
                margin-bottom: 10px;
              }
              .sc {
                line-height: 24px;
              }
            }
          }
        }
        .r {
          display: none;
        }
      }
    }
  }
</style>
